export interface IProjectInfo {
	customerName: string,
	customerAddresLine1: string,
	customerAddresLine2: string,
	orderCode: string,
	readonly orderNumber: string,
    externalId: string,
    postalCode: string,
    userId:  string
}

export class ProjectInfo implements IProjectInfo {
	customerName: string = "";
	customerAddresLine1: string = "";
	customerAddresLine2: string = "";
	orderCode: string = "";
	externalId: string = "";
	postalCode: string = "";
	userId: string = "";

	get orderNumber(): string {
		return this.orderCode;
	}

	constructor(init?: Partial<Omit<IProjectInfo, 'orderNumber'>>) {
		if (init) {
			Object.assign(this, init);
		}
	}

	toJSON(): IProjectInfo {
		return {
			customerName: this.customerName,
			customerAddresLine1: this.customerAddresLine1,
			customerAddresLine2: this.customerAddresLine2,
			orderCode: this.orderCode,
			orderNumber: this.orderNumber,
			externalId: this.externalId,
			postalCode: this.postalCode,
			userId: this.userId,
		};
	}
}

export interface ISysInfo {
	version: string,
	crmDelay: number,
	crmDelayCheck: number,
	crmErrors: boolean
}